import { FIXTURE_STATE_CONFIG } from "@/utils/constants.js";
import { REWARD_TYPE } from "@/hooks/contest/contestStatus.js";
import { GruppomimoStepWelcome } from "@/components/brandDemo/GruppomimoStepWelcome.jsx";
import { GruppomimoStepResult } from "@/components/brandDemo/GruppomimoStepResult.jsx";

const CDN = "https://cdn.prod.website-files.com/64e75b79eaa8eb84e0f6f6d7";

/**
 * Config de la démo de prospection GRUPPOMIMO.
 * Route : /gruppomimo
 *
 * Brand : Restaurant italien haut de gamme à Paris
 * Couleurs : rouge #C81124, crème chaude #F9F3DE, noir profond #1D1D1B
 */
export const GRUPPOMIMO_CONFIG = {

    /* ─── IDENTITÉ DE MARQUE ─────────────────────────────────────── */
    brand: {
        name: "GRUPPOMIMO",
        logoUrl: "https://cdn.prod.website-files.com/64e75b64860b4e3dc128e525/64f9dbf9e1d43620baa83313_favicon-256x256.png",
        logoLottieUrl: "https://cdn.prod.website-files.com/64e75b64860b4e3dc128e525/64ecf46ea5dd20deeba63cad_anim-logo-footer-v2.json",
        websiteUrl: "https://www.gruppomimo.com",

        fonts: {
            heading: "Poppins",
            body: "Poppins",
            googleFontsUrl: "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,600;0,700;0,900;1,700&display=swap",
        },

        colors: {
            pageBg:        "#F9F3DE", // crème chaude — identité Gruppomimo
            accent:        "#C81124", // rouge signature — CTA principaux
            accentText:    "#FFFFFF", // blanc sur rouge
            highlight:     "#F5B1D0", // rose brand (65 occurrences dans le CSS)
            highlightText: "#1D1D1B", // noir profond sur rose
            goalFlash:     "#F5B1D0", // flash "BUT !" rose brand
            error:         "#C81124",
        },
    },

    /* ─── ÉCRAN D'ACCUEIL ────────────────────────────────────────── */
    welcome: {
        partner: null,
        rewardImageUrl: "https://cdn.prod.website-files.com/64e75b79eaa8eb84e0f6f6d7/6824a37707f6127eb36ba490_classic%20queen.png",
        rewardTitle:    "Repas pour 2",
        rewardSubtitle: "chez Gruppomimo",
    },

    /* ─── ÉTAPE SEGMENTATION ─────────────────────────────────────── */
    segmentation: {
        products: [
            {
                id: "pizza",
                label: "Pizza",
                desc: "Truffle Mafia",
                imgUrl: "https://cdn.prod.website-files.com/64e75b79eaa8eb84e0f6f6d7/6824a3519f5f1a849dd75661_truffle%20mafia.png",
            },
            {
                id: "burrata",
                label: "Burrata",
                desc: "Queen B · Tomates & Basilic",
                imgUrl: "https://cdn.prod.website-files.com/64e75b64860b4e3dc128e525/64f7444ce11d28e2d0e70476_photos-food-_0055_%F0%9F%91%91-QUEEN-B-%F0%9F%91%91-Tomates-anciennes-%26-Basilico-w400.png",
            },
            {
                id: "tiramisu",
                label: "Tiramisu",
                desc: "Classico maison",
                imgUrl: "https://cdn.prod.website-files.com/64e75b64860b4e3dc128e525/64f74db8cc2910c803ce550a_photos-food-_0056_-classico-Tiramisu-w400.png",
            },
            {
                id: "pasta",
                label: "Pasta",
                desc: "Artichaut & truffe",
                imgUrl: "https://cdn.prod.website-files.com/64e75b79eaa8eb84e0f6f6d7/6824a3eae49ab67fa0fdde19_artichock.png",
            },
        ],
    },

    /* ─── ÉCRAN DE RÉSULTAT ──────────────────────────────────────── */
    result: {
        confettiColors: ["#C81124", "#F9F3DE", "#1D1D1B"],
        socials: [
            { platform: "instagram", url: "https://www.instagram.com/gruppomimo/" },
            { platform: "tiktok",    url: "https://www.tiktok.com/@gruppomimo" },
            { platform: "facebook",  url: "https://www.facebook.com/ciaogruppomimo/" },
        ],
    },

    /* ─── DONNÉES DE LA DÉMO ─────────────────────────────────────── */
    demoContest: {
        fixture: {
            type: "FOOTBALL",
            id: 10,
            startingAt: "2025-12-20 20:45:00",
            label: "Finale",
            state: FIXTURE_STATE_CONFIG.SECOND_HALF,
            minutes: 74,
            extraMinutes: null,
            league: { name: "DEMO CUP", logoUrl: null },
        },
        coverUrl: `${CDN}/64f764f5cda901ea21ae4fd1_photo-marquee-1-p-800.jpg`,
        place: {
            id: 10,
            name: "Gruppomimo – Rivoli",
            address: "14 Rue de Rivoli, 75004 Paris, France",
            googlePlaceId: "ChIJK6QpkTlv5kcRdl3qUFq6GOo",
        },
        defaultRewardLabel: "Un repas offert",
        defaultWinnerReward: { title: "Repas pour 2 offert",     type: REWARD_TYPE.PHYSICAL, code: "WIN-MIMO" },
        defaultLoserReward:  { title: "Tiramisu offert",         type: REWARD_TYPE.PHYSICAL, code: "LOSE-MIMO" },
        rewardsByLang: {
            fr: { rewardLabel: "Un repas pour 2 à gagner",         winnerReward: { title: "Repas pour 2 offert",               type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "Tiramisu Classico offert",      type: REWARD_TYPE.PHYSICAL, promoCode: "MIMO-TIRA" } },
            en: { rewardLabel: "Win a dinner for 2",               winnerReward: { title: "Dinner for 2 on us",                type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "Free Tiramisu Classico",        type: REWARD_TYPE.PHYSICAL, promoCode: "MIMO-TIRA" } },
            es: { rewardLabel: "Gana una cena para 2",             winnerReward: { title: "Cena para 2 invitados",             type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "Tiramisú Clásico de regalo",   type: REWARD_TYPE.PHYSICAL, promoCode: "MIMO-TIRA" } },
            it: { rewardLabel: "Vinci una cena per 2",             winnerReward: { title: "Cena per 2 offerta",                type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "Tiramisù Classico in omaggio", type: REWARD_TYPE.PHYSICAL, promoCode: "MIMO-TIRA" } },
            pt: { rewardLabel: "Ganhe um jantar para 2",           winnerReward: { title: "Jantar para 2 oferecido",           type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "Tiramisu Clássico grátis",     type: REWARD_TYPE.PHYSICAL, promoCode: "MIMO-TIRA" } },
            de: { rewardLabel: "Gewinne ein Abendessen für 2",     winnerReward: { title: "Abendessen für 2 Personen gratis",  type: REWARD_TYPE.PHYSICAL }, loserReward: { title: "Tiramisu Classico geschenkt",  type: REWARD_TYPE.PHYSICAL, promoCode: "MIMO-TIRA" } },
        },
    },

    /* ─── SURCHARGES DE COMPOSANTS ───────────────────────────────── */
    components: {
        StepWelcome: GruppomimoStepWelcome,
        StepResult:  GruppomimoStepResult,
    },
};
